(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('magzipp-live-inventory')) {
  customElements.define('magzipp-live-inventory', class extends HTMLElement {
    connectedCallback() {
      this.stock = JSON.parse(this.querySelector('[data-stock-initial]').textContent).variants;
      this.lastSuccess = Date.now();
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      this.onChange = () => { clearTimeout(this.changeTimer); this.changeTimer = setTimeout(() => this.render(), 150); };
      this.onFocus = () => this.refresh();
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('change', this.onChange);
      window.addEventListener('focus', this.onFocus);
      this.render();
      this.refresh();
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 20000);
    }
    render() {
      const form = document.getElementById(this.dataset.formId);
      const variantId = form?.querySelector('[name="id"]')?.value || String(this.stock[0]?.id);
      const item = this.stock.find(v => String(v.id) === String(variantId));
      this.hidden = !item?.tracked;
      if (!item?.tracked) return;
      const empty = item.quantity <= 0;
      const line = empty ? this.dataset.soldOut : this.dataset.inStock.replaceAll('[count]', new Intl.NumberFormat(document.documentElement.lang || 'en').format(item.quantity));
      const node = this.querySelector('[data-stock-line]');
      if (node.textContent !== line) node.textContent = line;
      this.dataset.empty = String(empty);
      this.querySelector('[data-stock-caption]').hidden = empty;
    }
    async refresh() {
      if (this.loading || !this.isConnected) return;
      this.loading = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', 'magzipp-inventory-data');
        url.searchParams.set('_stock', String(Date.now()));
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Inventory unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = JSON.parse(html.querySelector('[data-magzipp-inventory-data]').textContent);
        if (!Array.isArray(payload.variants) || payload.variants.some(v => typeof v.tracked !== 'boolean' || (v.tracked && (!Number.isInteger(v.quantity) || v.quantity < 0)))) throw new Error('Invalid inventory');
        this.stock = payload.variants;
        this.lastSuccess = Date.now();
        this.render();
      } catch {
        if (this.lastSuccess && Date.now() - this.lastSuccess > 120000) this.hidden = true;
      } finally {
        clearTimeout(timeout);
        this.loading = false;
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.changeTimer);
      this.controller?.abort();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('focus', this.onFocus);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

if (!customElements.get('magzipp-live-inventory')) {
  customElements.define('magzipp-live-inventory', class extends HTMLElement {
    connectedCallback() {
      this.stock = JSON.parse(this.querySelector('[data-stock-initial]').textContent).variants;
      this.lastSuccess = Date.now();
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      this.onChange = () => { clearTimeout(this.changeTimer); this.changeTimer = setTimeout(() => this.render(), 150); };
      this.onFocus = () => this.refresh();
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('change', this.onChange);
      window.addEventListener('focus', this.onFocus);
      this.render();
      this.refresh();
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 20000);
    }
    render() {
      const form = document.getElementById(this.dataset.formId);
      const variantId = form?.querySelector('[name="id"]')?.value || String(this.stock[0]?.id);
      const item = this.stock.find(v => String(v.id) === String(variantId));
      this.hidden = !item?.tracked;
      if (!item?.tracked) return;
      const empty = item.quantity <= 0;
      const line = empty ? this.dataset.soldOut : this.dataset.inStock.replaceAll('[count]', new Intl.NumberFormat(document.documentElement.lang || 'en').format(item.quantity));
      const node = this.querySelector('[data-stock-line]');
      if (node.textContent !== line) node.textContent = line;
      this.dataset.empty = String(empty);
      this.querySelector('[data-stock-caption]').hidden = empty;
    }
    async refresh() {
      if (this.loading || !this.isConnected) return;
      this.loading = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', 'magzipp-inventory-data');
        url.searchParams.set('_stock', String(Date.now()));
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Inventory unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = JSON.parse(html.querySelector('[data-magzipp-inventory-data]').textContent);
        if (!Array.isArray(payload.variants) || payload.variants.some(v => typeof v.tracked !== 'boolean' || (v.tracked && (!Number.isInteger(v.quantity) || v.quantity < 0)))) throw new Error('Invalid inventory');
        this.stock = payload.variants;
        this.lastSuccess = Date.now();
        this.render();
      } catch {
        if (this.lastSuccess && Date.now() - this.lastSuccess > 120000) this.hidden = true;
      } finally {
        clearTimeout(timeout);
        this.loading = false;
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.changeTimer);
      this.controller?.abort();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('focus', this.onFocus);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
